import { Box, Button, Dialog, DialogProps, Grid } from "@material-ui/core";
import { Form, Formik } from "formik";
import { useSnackbar } from "notistack";
import React from "react";
import {
    InputFieldFormik,
    SubmitButton,
    Title,
    yupMaxLengthField,
    yupMinLengthField,
    yupRequiredField,
} from "ui/componentes";
import * as Yup from "yup";

const RequestReviewValidation = Yup.object().shape({
    description: Yup.string()
        .required(yupRequiredField)
        .min(50, yupMinLengthField)
        .max(300, yupMaxLengthField),
});

interface IncidentReviewRequestDialogProps {
    onSave: (description: string) => Promise<any>;
}

const IncidentReviewRequestDialog: React.FC<
    DialogProps & IncidentReviewRequestDialogProps
> = ({ onSave, ...props }) => {
    const { enqueueSnackbar } = useSnackbar();
    return (
        <Formik
            enableReinitialize={true}
            initialValues={{
                description: "",
            }}
            validationSchema={RequestReviewValidation}
            onSubmit={(values, { setSubmitting, resetForm }) => {
                onSave(values.description)
                    .then(() => {
                        enqueueSnackbar(
                            "Pedido para revisão de penalidade enviado",
                            {
                                variant: "success",
                            }
                        );
                    })
                    .catch((error) => {
                        console.error(error.code);

                        let errorMessage =
                            "Erro ao enviar pedido para revisão de penalidade";
                        if (error.code === "permission-denied") {
                            errorMessage =
                                "Você não tem permissão para pedir revisão sobre esse incidente";
                        }
                        if (error.code === "deadline-exceeded") {
                            errorMessage =
                                "Prazo para pedir revisão sobre esse incidente encerrado";
                        }

                        enqueueSnackbar(errorMessage, {
                            variant: "error",
                        });
                    })
                    .finally(() => {
                        setSubmitting(false);
                        resetForm();
                    });
            }}
        >
            {({ values, isSubmitting, resetForm }) => {
                return (
                    <Dialog
                        open={props.open}
                        maxWidth="md"
                        onClose={(event, reason) => {
                            if (props.onClose) {
                                props.onClose(event, reason);
                            }
                            resetForm();
                        }}
                    >
                        <Form>
                            <Box p={3}>
                                <Grid container spacing={1}>
                                    <Grid item xs={12}>
                                        <Title text="Solicitar reavalição de penalidade" />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <InputFieldFormik
                                            required
                                            id="description"
                                            name="description"
                                            label="Descrição"
                                            multiline
                                            rows={6}
                                            helperText={`Max.: ${values.description.length} / 300`}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <Button
                                            fullWidth
                                            onClick={() => {
                                                if (props.onClose) {
                                                    props.onClose(
                                                        {},
                                                        "escapeKeyDown"
                                                    );
                                                }
                                                resetForm();
                                            }}
                                        >
                                            Cancelar
                                        </Button>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <SubmitButton fullWidth>
                                            {isSubmitting
                                                ? "Enviando pedido"
                                                : "Enviar"}
                                        </SubmitButton>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Form>
                    </Dialog>
                );
            }}
        </Formik>
    );
};

export { IncidentReviewRequestDialog };
